var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.propVal
    ? _c("div", { staticClass: "propval d-flex" }, [
        _c(
          "div",
          [
            _vm.name
              ? [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")]
              : [_vm._v("\n        " + _vm._s(_vm.propTitle) + "\n      ")],
          ],
          2
        ),
        _vm._v(" "),
        _c("div", [_vm._v("\n      " + _vm._s(_vm.propVal) + "\n    ")]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }